import { PropsWithChildren, ReactNode } from 'react';
import { IoClose } from 'react-icons/io5';
import { Modal, ModalBody, ModalContent, ModalHeader, Spinner } from '@ds';

type SizeType = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl' | 'full' | undefined;

export type RoutePlannerModalLayoutProps = {
  title: string | ReactNode;
  baseClassName?: string;
  isOpen: boolean;
  isLoading?: boolean;
  onClose: () => void;
  size: SizeType;
  headerTitleClassName?: string;
  closeButtonClassName?: string;
  bodyClassName?: string;
};

export const RoutePlannerModal = ({
  baseClassName,
  title,
  children,
  isOpen,
  isLoading = false,
  onClose,
  size,
  headerTitleClassName = 'text-hl!',
  closeButtonClassName = 'text-base-10 m-4',
  bodyClassName = 'p-4',
}: PropsWithChildren<RoutePlannerModalLayoutProps>) => {
  return (
    <Modal
      size={size}
      isOpen={isOpen}
      onClose={onClose}
      scrollBehavior="inside"
      closeButton={<IoClose size={42} className="z-1000" />}
      classNames={{
        ...(baseClassName ? { base: baseClassName } : {}),
        body: `${bodyClassName} bg-base-80 rounded-md relative`,
        wrapper: 'flex items-center z-420',
        backdrop: 'z-419',
        closeButton: closeButtonClassName,
        header: `${headerTitleClassName} text-base-20 font-secondary flex flex-col gap-1 bg-base-80 rounded-md`,
      }}
    >
      <ModalContent>
        {isLoading && (
          <div className="absolute top-0 left-0 flex justify-center items-center rounded-md z-50 w-full h-full bg-white bg-opacity-40">
            <Spinner size="md" />
          </div>
        )}
        <ModalHeader>{title}</ModalHeader>
        <ModalBody>{children}</ModalBody>
      </ModalContent>
    </Modal>
  );
};
